export default "__VITE_ASSET__CaPGHo17__"